// extracted by mini-css-extract-plugin
export default {"alertModal":"styles_alertModal__q4da7"};